'use client';
import type { UserOnboardingPrimary } from '@/types/zones/slices/user-onboarding';
import dynamic from 'next/dynamic';
import { getGame } from '@/logic/game-info/game-info';
import { useStore } from '@/store/store';
import { POPUPS } from '@/app/components/popup/constants';
import { useCasinoUserProfileUm } from '@/hooks/use-casino-user-profile-um';
import './styles/@theme';

const WelcomeLobbyMessageUM = dynamic(
    () => import('@fanduel/casino-user-profile-web').then((m) => m.WelcomeLobbyMessage),
    { ssr: false }
);

const CasinoUserProfileProvider = dynamic(
    () => import('@fanduel/casino-user-profile-web').then((m) => m.CasinoUserProfileProvider),
    { ssr: false }
);

export const WelcomeLobbyMessage = (props: { data: UserOnboardingPrimary }) => {
    const { queuePopup } = useStore((s) => s.popup);

    useCasinoUserProfileUm();

    const handleGameInfoClick = async (gameUid: string) => {
        const game = await getGame(gameUid);
        if (!game?.uid) return;
        queuePopup({
            type: POPUPS.GAME_INFO,
            params: {
                ...game,
                originPageName: 'home',
                originZoneName: 'welcome_lobby_message'
            }
        });
    };

    return (
        <div className="welcome-lobby-message-zone">
            <CasinoUserProfileProvider onGameInfoClick={handleGameInfoClick}>
                <WelcomeLobbyMessageUM
                    title={props.data?.welcome_title?.[0]?.text ?? ''}
                    cta={props.data?.avatar_cta?.[0]?.text ?? ''}
                />
            </CasinoUserProfileProvider>
        </div>
    );
};
